import request from './request';
import { getAppName } from './appBase';
import { downloadOrOpenApp, directDownload } from './appdownload';
import { detectStatus, localAppStatus } from './appdownloadUtil';
import { statTicket, statTicketSync } from './stat';
import { query, getArticleIdFromUrl, getVideoIdFromUrl, getdocIdFromUrl } from './yUtil';
import { APP_INFO } from './constant';
import { parseUrl } from './url';
import { POST_MATCH_PROFILE_LIST } from '../urls';
import { getSourceUrl } from './videoData';

export {
  getAppName,
  downloadOrOpenApp,
  statTicket,
  statTicketSync,
  query,
  detectStatus,
  getArticleIdFromUrl,
  getVideoIdFromUrl,
  localAppStatus,
  getdocIdFromUrl,
  directDownload
}

const detailURLCofigMap = {
  article: {
    ChannelID: "com.tencent.mm",
    PosID: "122144",
    ch: "003539"
  },
  video: {
    ChannelID: "com.tencent.mm",
    PosID: "122145",
    ch: "003540"
  }
}


let tip = null;
let tipTimer = null;
export function showTip(text, time = 1500) {
  if (tip) {
    tip.innerText = text
    tip.style['pointer-events'] = 'all'
    tip.style.opacity = 1
  } else {
    tip = document.createElement('div')
    tip.className = 'kb-tip'
    tip.innerText = text
    document.body.appendChild(tip)
  }

  if (tipTimer) {
    clearTimeout(tipTimer)
  }

  tipTimer = window.setTimeout(() => {
    tip.style.opacity = 0
    tip.style['pointer-events'] = 'none'
    tipTimer = null
  }, time)
}

export const appOriginHosts = {
  qb: 'https://news.html5.qq.com/article',
  extreme_qb: 'https://news.html5.qq.com/share',
  novel_qb: 'https://news.html5.qq.com/share',
  young_qb: 'https://news.html5.qq.com/article'
}

/**
 * @desc 获取各应用正文详情页真实url
 */
export const getArticleDetailUrl = ({ qs = '', name = 'qb', docId = getArticleIdFromUrl(), isShort = false, channel }) => {
  if (name === 'qb' || name === 'extreme_qb' || name === 'novel_qb' || name === 'young_qb') {
    let ch = channel || detailURLCofigMap.article.ch
    let contenturl = encodeURIComponent(`${appOriginHosts[name]}?docId=${docId}`)
    return `qb://ext/read?cid=MttTagSource&type=3&mttsummaryid=${docId}&b_f=23644&bizid=1&ch=${ch}&contenturl=${contenturl}%26ch%3D${ch}&module=infocontent&component=infocontent&cardmode=1&infoCacheStatus=1&qb_preload_bus=10003&qb_preload=1&qb_preload_cache_key=preloadarticle_${docId}`
  } else if (name === 'kb') {
    if (isShort) {
      return APP_INFO[name].webViewUrl.replace(/{openUrl}/g, `https://quan.qq.com/fun/${docId}`)
    } else {
      return APP_INFO[name].runUrl.replace(/{docId}/g, docId)
    }
  }
}

/**
 * @desc gsp人群匹配方法
 * 1. 指定guid
 * 2. 未指定guid，服务端从header或cookie中获取可能存在的guid进行匹配
 *
 * @param {*} guid
 * @param {*} [profileIDList=[]]
 * @returns
 */

export const profileMatch = async (guid, profileIDList = []) => {
  if (window._configs && window._configs.profileIdMatchList) return window._configs.profileIdMatchList

  try {
    const result = await request.post(POST_MATCH_PROFILE_LIST, {
      guid,
      profileIDList
    })

    if (result.code === 0) {
      window._profileList = result.data.vMatchList
      return window._profileList
    }
    return []
  } catch (err) {
    console.log('profileMatch err', err)
    return []
  }
}

/**
* @desc 获取各应用视频详情页真实url
*/

export const getVideoDetailUrl = ({ videoItem = {}, name = 'qb', docId = getVideoIdFromUrl(), contentUrl = "", channel }) => {
  if (name === 'qb' || name === 'extreme_qb' || name === 'novel_qb' || name === 'young_qb') {
    const urlObj = parseUrl(window.location.href) || {};
    const { imageUrl: defaultImageUrl, cdnPlayInfo = {} } = window._configs.videoContent || {};
    const videoPlayUrl = getSourceUrl(window._configs.videoContent || {});
    const defaultVideoUrl = cdnPlayInfo.srcVideoId ? `h5tenvideo://${cdnPlayInfo.srcVideoId}` : '';

    console.log("defaultImageUrl", defaultImageUrl, "defaultVideoUrl", defaultVideoUrl);

    const expiretime = cdnPlayInfo.expireTime;
    const ch = channel || detailURLCofigMap.video.ch;

    const query = urlObj.query || {};
    const kandianTab = query.kandianTab;
    const rowkey = query.rowkey;
    const type = query.cardtype;
    const transferInfo = query.transferInfo;

    const videoUrl = encodeURIComponent(videoItem.videoUrl || videoPlayUrl || defaultVideoUrl);
    const encodeImageUrl = encodeURIComponent(videoItem.imageUrl || videoItem.imgUrl || defaultImageUrl);

    //看点tab短视频和小视频视频浮层承接
    if (kandianTab === "1" && rowkey && type && videoItem.subpose === "sharelp_top_bar_app") {
      const encodeExtinfo = encodeURIComponent(`appid=43&ch=${ch}&ctr_scenes_id=1&vid=${docId}`);

      const fixParams = 'qb://ext/rn?module=ugcfloat&component=ugcfloat&page=kandian&orientation=1&coverToolbar=true&backgroundColor=%23000000&sh_na_id=1007&preloadShell=1&useShell=1&newUI=1&newCommentUI=1&';
      const dynamicParams = `videoUrl=${videoUrl}&currentId=${docId}&imgUrl=${encodeImageUrl}&clickTimeStamp=${new Date().valueOf()}&extinfo=${encodeExtinfo}&rowkey=${rowkey}&type=${type}${transferInfo ? `&transferInfo=${encodeURIComponent(transferInfo)}` : ''}${expiretime ? `&expiretime=${expiretime}` : ''}`;

      const url = `${fixParams}${dynamicParams}&qbAppendInfo=`;
      console.log('videoUrl', url);
      return url;
    } else {
      // 短小视频均走小视频浮层链路
      const encodeExtinfo = encodeURIComponent(`appid=43&ch=${ch}&ctr_scenes_id=1&vid=${docId}&log_version=1&videotype=${videoItem.classify === 1 ? '1' : '2'}`);

      const fixParams = 'qb://ext/rn?module=ugcfloat&component=ugcfloat&page=ugc&orientation=1&coverToolbar=true&backgroundColor=%23000000&sh_na_id=1007&preloadShell=1&useShell=1&newUI=1&newCommentUI=1&';
      const dynamicParams = `videoUrl=${videoUrl}&currentId=${docId}&imgUrl=${encodeImageUrl}&clickTimeStamp=${new Date().valueOf()}&videoBusiType=${videoItem.classify === 1 ? '2' : '1'}&extinfo=${encodeExtinfo}${transferInfo ? `&transferInfo=${encodeURIComponent(transferInfo)}` : ''}${expiretime ? `&expiretime=${expiretime}` : ''}`;

      const url = `${fixParams}${dynamicParams}&qbAppendInfo=`;
      console.log('videoUrl', url);
      return url;
    }
  } else if (name === 'kb') {
    return APP_INFO[name].runUrl.replace(/{docId}/g, docId)
  }
}
